// extracted by mini-css-extract-plugin
export default {"title":"accordian_title__jybGD","container":"accordian_container__szURy","accordian":"accordian_accordian__xbMOi"};